import request from '../utils/request'


export function index(params) {
  return request({
    url: '/injuryTypes',
    method: 'get',
      params
  })
}

export function inventory(params) {
  return request({
    url: '/injuryTypes/inventory',
    method: 'get',
    params
  })
}

  

export function show(id) {
    return request({
      url: `/injuryTypes/${id}`,
      method: 'get'
    })
  }

  export function store(data) {
    return request({
      url: '/injuryTypes',
      method: 'post',
      data
    })
  }

  export function update(data) {
    return request({
      url: `/injuryTypes/${data.id}`,
      method: 'put',
      data
    })
  }

  export function destroy(id) {
    return request({
      url: `/injuryTypes/${id}`,
      method: 'delete',
    })
  }
